import type { SeoResolver } from '../types';

/** SEO for a selected local body (corporation / municipality / panchayat). Moved verbatim from SEO.tsx. */
export const localBodySeoResolver: SeoResolver = (ctx) => {
  const lb = ctx.selections.localBody;
  if (!lb) return null;

  const { siteName } = ctx;
  const p = lb.properties;

  return {
    title: `${p.name} ${p.type || 'Local Body'} | ${siteName}`,
    description: `Explore ward boundaries and local governance details for ${p.name} (${p.type || 'Local Body'}) on ${siteName} GIS.`,
    breadcrumbLabel: p.name
  };
};
